module.exports = __webpack_public_path__ + "img/172.93c1a674.jpg";